import { ReactNode, useMemo } from 'react'
import { useAuthStore } from '@features/auth'
import { getTickerSubscriptionSymbols, useTickerSocket } from '@features/market'
import { useAccountList, useUserAccSocket, usePositions, useOpenOrders } from '@features/account'
import { selectBotFormTrading, useBotAllList, useBotFormStore } from '@features/bot'
import { useFavorites } from '@features/user'

export const SocketProvider = ({ children }: { children: ReactNode }) => {
  const isLoggedIn = useAuthStore(s => s.isLoggedIn)
  const svrId = useAuthStore(s => s.svrId)
  const { selectedSymbol } = useBotFormStore(selectBotFormTrading)
  const { isAccountReady } = useAccountList({ enabled: !!svrId })
  // const userId = useAuthStore(s => s.userId)

  const connected = isLoggedIn && !!svrId && isAccountReady
  const { favoriteSymbols, isLoading: isFavoritesLoading } = useFavorites({ enabled: connected })
  const {
    items: runningBots,
    allItems: bots,
    isLoading: isBotsLoading,
  } = useBotAllList({ enabled: connected })
  const hasRunningBots = runningBots.length > 0
  const tickerSymbols = useMemo(
    () => getTickerSubscriptionSymbols(favoriteSymbols, bots, [selectedSymbol]),
    [favoriteSymbols, bots, selectedSymbol],
  )
  const tickerConnected = connected && !isFavoritesLoading && !isBotsLoading

  useTickerSocket(tickerConnected, tickerSymbols)
  useUserAccSocket(connected, { watchdogEnabled: hasRunningBots })
  usePositions(connected)
  useOpenOrders(connected)

  return <>{children}</>
}
